export const validateInput = (curr: any, t: any) => {
  //Note validate and display error is 2 separate functions b/c w/ button disabled only want to check, not show error
  let returnVal: any = false;
  let msg: string = '';

  if (Array.isArray(curr['content'])) {
    if (curr['content'].length === 0) {
      return {
        error: true,
        msg: t('sellerProfile.dashboard.validation.required')
      };
    } else {
      return { error: false, msg: '' };
    }
  }
  let content = curr['content']?.trim();
  if (curr['validate'] === 'text') {
    if (curr['content'].length === 0) {
      return {
        error: true,
        msg: t('sellerProfile.dashboard.validation.required')
      };
    }
  } else if (curr['validate'] === 'iata' || curr['validate'] === 'iataNumber') {
    if (!curr['content'] || curr['content'].trim().length === 0) {
      // If required, show required error, else no error
      if (curr['required'] === 'true') {
        return { error: true, msg: t('sellerProfile.dashboard.validation.required') };
      }
      return { error: false, msg: '' };
    }
    if (!/^[0-9]{8}$/.test(curr['content'])) {
      return { error: true, msg: t('sellerProfile.dashboard.validation.iata') };
    }
    return { error: false, msg: '' };
  }
  //Un utilisateur est déjà associé à cette adresse électronique.
  //Veuillez entrer une adresse électronique valide (les adresses personnelles ne sont pas autorisées).
  //Veuillez saisir un numéro de téléphone valide.
  if (curr['content']?.length && curr['validate']) {
    if (curr['validate'] === 'email') {
      let re = /\S+@\S+\.\S+/;
      returnVal = !re.test(content);

      const blacklist = [
        '@gmail.',
        '@yahoo.',
        '@hotmail.',
        '@aol.',
        '@msn.',
        '@outlook.',
        '@mail.',
        '@protonmail.',
        '@zoho.',
        '@icloud.',
        '@gmx.',
        '@yandex.',
        '@fastmail.',
        '@tutanota.',
        '@hushmail.',
        '@runbox.',
        '@inbox.',
        '@zimbra.',
        '@sapo.pt',
        '@walla.'
      ];

      blacklist.forEach((b) => {
        if (content.includes(b)) {
          returnVal = true;
        }
      });
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.email');
      }
    } else if (curr['validate'] === 'phone') {
      let re = /^[0-9+(][0-9 \-().]{7,14}$/;
      //Allows 7 - 32 numbers and + . () - and spaces only
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.phone');
      }
    } else if (curr['validate'] === 'url') {
      let re =
        /^[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.url');
      }
    } else if (curr['validate'] === 'alpha') {
      let re = /^[a-zA-Z.,\- ]*$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.alpha');
      }
    } else if (curr['validate'] === 'alphanumeric') {
      let re = /^[a-zA-Z0-9,. ]*$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.alphanumeric');
      }
    } else if (curr['validate'] === 'numeric') {
      let re = /^[0-9., ]*$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.numeric');
      }
    } else if (curr['validate'] === 'numericpercent') {
      let re = /^[0-9%:,.]*$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.numericpercent');
      }
    }
    else if (curr['validate'] === 'ipAddress') {
      let re = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.ipAddress');
      }
    }
  }
  return { error: returnVal, msg: msg };
};


// Reusable predicate functions — kept separate so profiles can share them
export const rules = {
  noHtml:         (v: string) => !/<|>|\{|\}|\\/.test(v),
  digitsOnly:     (v: string) => !v || /^\d+$/.test(v),
  maxLength8:     (v: string) => !v || v.length <= 8,
  validUrl:       (v: string) => !v || !v.trim() || /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g.test(v.trim()),
  validPhone:     (v: string) => !v || !v.trim() || /^[0-9 \-().+]{7,32}$/.test(v.trim()),
  validEmailFmt:  (v: string) => !v || !v.trim() || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()) && v.length > 3,
  noFreeEmail:    (v: string) => {
    if (!v || !v.trim()) return true;
    const domain = v.split('@')[1]?.toLowerCase() ?? '';
    return !["gmail.com",
      "yahoo.com",
      "hotmail.com",
      "aol.com",
      "msn.com",
      "outlook.com",
      "mail.com",
      "protonmail.com",
      "zoho.com",
      "icloud.com",
      "gmx.com",
      "yandex.com",
      "fastmail.com",
      "tutanota.com",
      "hushmail.com",
      "runbox.com",
      "inbox.com",
      "zimbra.com",
      "sapo.pt.com",
      "walla.com"
    ]
      .includes(domain);
  },
  validDecimalFmt: (v: string) => !v || !v.trim() || /^\d+(\.\d+)?$/.test(v.trim()),
  decimalInRange:  (v: string) => {
    if (!v || !v.trim()) return true;
    const n = parseFloat(v);
    return n >= 0 && n <= 100;
  },
  validIATA: (v: string) => !v || !v.trim() || /^[0-9]{8}$/.test(v.trim()),
  salesMixEquals100: (v: string, v2: string, v3: string) => {
    const sum = Math.round(
      ((parseFloat(v) || 0) + (parseFloat(v2) || 0) + (parseFloat(v3) || 0)) * 100
    ) / 100;
    return sum === 100;
  },
};